import { render, staticRenderFns } from "./ApresentacaoFotos.vue?vue&type=template&id=a44cd4bc"
import script from "./ApresentacaoFotos.vue?vue&type=script&lang=js"
export * from "./ApresentacaoFotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports